﻿class LocalComments {
    static getComment(ticketId: string) {
        const comments = JSON.parse(localStorage.getItem('comments')!);
        return comments ? comments[ticketId] : null;
    }

    static saveComment(ticketId: string, comment: string) {
        let comments = JSON.parse(localStorage.getItem('comments')!);

        if (comments) {
            comments[ticketId] = comment;
        }
        else {
            comments = { [ticketId]: comment };
        }

        localStorage.setItem('comments', JSON.stringify(comments));
    }

    static deleteComment(ticketId: string) {
        const comments = JSON.parse(localStorage.getItem('comments')!);
        /**
         * если localStorage равен undefined или {}, то выходим из функции
         * */
        if (comments?.[ticketId]) {
            delete comments[ticketId];
            localStorage.setItem('comments', JSON.stringify(comments));
        }
    }
}

window.LocalComments = LocalComments;